import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate("/", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId },
          withCredentials: true
        });

        const user = response.data.user;
        setUser(user);

        // Clear hash and redirect based on role
        window.history.replaceState(null, "", window.location.pathname);
        
        if (user.role === "super_admin") {
          navigate("/admin", { replace: true, state: { user } });
        } else if (user.role === "salon_admin") {
          navigate("/dashboard", { replace: true, state: { user } });
        } else {
          navigate("/dashboard", { replace: true, state: { user } });
        }
      } catch (error) {
        console.error("Auth error:", error);
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-pulse-glow mb-4">
          <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center mx-auto">
            <div className="w-6 h-6 rounded-full bg-accent"></div>
          </div>
        </div>
        <p className="text-muted-foreground">Autenticazione in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
